import type {RichTextField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {PrismicRichText} from '@prismicio/react'
import cn from 'classnames'

type SectionHeaderProps = {
  eyebrow?: RichTextField
  heading?: RichTextField
  description?: RichTextField
  smallerFontSize?: boolean
}

export const SectionHeader = ({eyebrow, heading, description, smallerFontSize}: SectionHeaderProps) => (
  <div className="flex flex-col gap-6">
    {isFilled.richText(eyebrow) && (
      <PrismicRichText
        field={eyebrow}
        components={{
          paragraph: ({children}) => <p className="text-button-s uppercase text-moss-blue">{children}</p>,
        }}
      />
    )}
    {isFilled.richText(heading) && (
      <div className="flex flex-col gap-6">
        <PrismicRichText
          field={heading}
          components={{
            heading2: ({children}) => (
              <h2
                className={cn('md:text-h2 text-[32px] font-medium leading-[normal] text-moss-black', {
                  '!text-[32px] !leading-normal': smallerFontSize,
                })}
              >
                {children}
              </h2>
            ),
            strong: ({children}) => <strong className="font-medium text-moss-black/60">{children}</strong>,
          }}
        />
        <PrismicRichText
          field={description}
          components={{
            paragraph: ({children}) => (
              <p
                className={cn('text-tg-body-l w-full text-grey-550 md:w-[440px]', {
                  '!text-[32px]': smallerFontSize,
                })}
              >
                {children}
              </p>
            ),
          }}
        />
      </div>
    )}
  </div>
)
